const ko = require('knockout');
const $ = require('jquery');
const pushConversionChuteEvent = require('push-conversion-chute-event');

const trimUnwrap = x => (ko.unwrap(x) || '').trim();

ko.bindingHandlers.inputGtmProcessing = {
	init (element, valueAccessor) {
		const defaultParams = {
			observable: ko.observable(),
			startEventValue: '',
			successEventValue: '',
			failureEventValue: '',
			clickEventValue: '',
			mouseoverEventValue: '',
			checkEventValue: '',
			uncheckEventValue: '',
			chooseEventValue: '',
			changeDetection: false,
			chosenValue: {},
		};

		const $el = $(element);
		const params = $.extend(defaultParams, valueAccessor());

		const startEventValue = trimUnwrap(params.startEventValue);
		const successEventValue = trimUnwrap(params.successEventValue);
		const failureEventValue = trimUnwrap(params.failureEventValue);
		const clickEventValue = trimUnwrap(params.clickEventValue);
		const mouseoverEventValue = trimUnwrap(params.mouseoverEventValue);
		const checkEventValue = trimUnwrap(params.checkEventValue);
		const uncheckEventValue = trimUnwrap(params.uncheckEventValue);
		const chooseEventValue = trimUnwrap(params.chooseEventValue);
		const chosenValue = params.chosenValue;
		const changeDetection = params.changeDetection;
		const getFreshObservable = () => valueAccessor().observable;

		const focusEventParams = ko.unwrap(params.focusEventParams);

		if (chooseEventValue) {
			$el.click(() => {
				pushConversionChuteEvent(chooseEventValue, chosenValue);
			});
		}

		if (checkEventValue) {
			const observable = getFreshObservable();
			// TODO: disposal
			observable.subscribe((v) => {
				if (v) {
					pushConversionChuteEvent(checkEventValue);
				}
			});
		}

		if (uncheckEventValue) {
			const observable = getFreshObservable();
			// TODO: disposal
			observable.subscribe((v) => {
				if (!v) {
					pushConversionChuteEvent(uncheckEventValue);
				}
			});
		}

		if (mouseoverEventValue) {
			$el.mouseover(() => {
				pushConversionChuteEvent(mouseoverEventValue);
			});
		}

		if (clickEventValue) {
			$el.click(() => {
				pushConversionChuteEvent(clickEventValue);
			});
		}

		if (startEventValue || focusEventParams) {
			$el.focus(() => {
				if (focusEventParams) {
					const { event, data} = focusEventParams;
					pushConversionChuteEvent(event, data);
				} else {
					pushConversionChuteEvent(startEventValue);
				}
			});
		}

		if (successEventValue || failureEventValue) {
			const check = () => {
				const observable = getFreshObservable();
				if (successEventValue && observable.isValid()) {

					pushConversionChuteEvent(successEventValue);
				} else if (failureEventValue) {

					pushConversionChuteEvent(failureEventValue, {
						formErrors:
						Array.isArray(observable.error())
							? observable.error()[0]
							: observable.error(),
					});
				}
			};

			const changeDetectionCheck = () => {
				const observable = getFreshObservable();
				// TODO: disposal
				observable.subscribe(() => {
					if (successEventValue && observable.isValid()) {

						pushConversionChuteEvent(successEventValue);
					} else if (failureEventValue) {

						pushConversionChuteEvent(failureEventValue, {
							formErrors:
							Array.isArray(observable.error())
								? observable.error()[0]
								: observable.error(),
						});
					}
				});
			};

			if (changeDetection) {
				changeDetectionCheck();
			} else {
				$el.blur(check);
			}
		}
	},
};
